import axios from 'axios';
import { ENV } from '../constants';
import { criarInterceptorDeRenovacao } from '../utils/criarInterceptorDeRenovacao';
import { tratarIndisponibilidade } from '../utils/tratarIndisponibilidade';

const auth = axios.create({
  baseURL: ENV.REACT_APP_AUTH_HOST || 'http://localhost:3334',
  headers: {
    'x-tenant-id': ENV.REACT_APP_TENANT_ID,
  },
});

export const tratarErro401 = criarInterceptorDeRenovacao(auth);
auth.interceptors.response.use(response => response, tratarErro401);
auth.interceptors.response.use(response => response, tratarIndisponibilidade);

export default auth;
